
import { Vue, Options } from 'vue-class-component'
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcode'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useStore } from '@/store'
import { getDisplayPoint } from '@/utils/functions'
import { DATE_FORMAT, getDate } from '@/helpers/date'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'
import { getUrlModalOptionsMyCoupon, modalOptionsCouponBZB } from '@/model/modal-options.model'
import ModalIframeOptions from '@/interfaces/modal-iframe-options'
import { MyCoupon } from '@/model/my-coupon.model'
import liff from '@line/liff'

library.add(faXmark)

@Options({
  components: {
    FontAwesomeIcon
  }
})
export default class ModalBarcode extends Vue {
  store = useStore()
  clubcardNo = this.store.state.customer.clubcardNo!
  points = this.store.state.customer.points
  tieredPoints = this.store.state.customer.tieredPoints
  customerType = this.store.state.customer?.customerType
  // Lite tier = customerType 'online'
  isLite = this.store.state.customer?.customerType === 'online'
  phoneNumber = this.store.state.customer?.phoneNumber ?? ''
  customerTier = this.store.state.tier?.tierName?.toLocaleUpperCase() ?? ''

  mounted() {
    this.generateBarcode()
    this.generateQRcode()
  }

  upgradeToLoyalty() {
    liff.openWindow({
      url: process.env.VUE_APP_ACTIVATE_LOYALTY_URL!
    })
  }

  closeModal() {
    this.$emit('close')
  }

  getLabelPoints(): string {
    return this.points !== undefined ? getDisplayPoint(this.points) : 'N/A'
  }

  getLabelTieredPoints(): string | undefined {
    if (!this.tieredPoints) {
      return
    }

    const expiringPoints = parseFloat(this.tieredPoints[0].expiringPoints)
    const points = getDisplayPoint(expiringPoints)
    const date = getDate(this.tieredPoints[0].date, DATE_FORMAT)

    return `${points} คอยน์ หมดอายุ ${date}`
  }

  generateBarcode() {
    JsBarcode('#barCode', this.clubcardNo, {
      height: 73,
      fontSize: 18,
      font: 'Lotuss Smart HL',
      margin: 0
    })
  }

  generateQRcode() {
    const qrCode = document.getElementById('qrCode') as HTMLElement
    QRCode.toCanvas(qrCode, this.clubcardNo, {
      margin: 2,
      scale: 1,
      width: 180
    })
  }

  openCoinHistory() {
    this.store.dispatch('coinHistory/onOpen', true)
    addGAEvent({
      event: 'mylotuss_coins_expoiry_details'
    })
  }

  openModalCouponBZB() {
    const customerType = this.store.state.customer?.customerType ?? undefined
    const socialToken = this.store.state.lineInfo?.socialToken ?? undefined
    modalOptionsCouponBZB.url = getUrlModalOptionsMyCoupon(undefined, 'lifestyle', 'offer', undefined, customerType, socialToken)
    this.updateModalIframe(true, modalOptionsCouponBZB)
    this.updateGAEvent(MyCoupon.COUPON_LIFESTYLE_TITLE)
  }

  updateModalIframe(isActive: boolean, modalOptions: ModalIframeOptions) {
    this.store.commit('modalIframe/updateModalIframeActive', isActive)
    this.store.commit('modalIframe/updateModalOptionsIframe', modalOptions)
  }

  updateGAEvent(txtTab: string) {
    addGAEvent({
      event: 'mylotuss_icon_tab',
      icon_tab: txtTab
    })
  }
}
